<template>
  <v-container>
    <v-card-actions>
      <v-spacer />
      <action-menu entity="account" :title="$tc('entities.account.title',1)" :data="value" />
    </v-card-actions>
    <v-tabs v-model="tab" vertical>
      <v-tab key="General">{{$t('general')}}</v-tab>
      <v-tab key="CustomFields">{{$t('customFields')}}</v-tab>
      <v-tabs-slider></v-tabs-slider>
      <v-tabs-items v-model="tab">
        <v-tab-item key="General">
          <v-form ref="form" v-model="valid">
            <v-text-field
              :label="$t('entities.account.props.code')"
              v-model="value.code"
              clearable
              :rules="$isRequiredRule"
            ></v-text-field>
            <v-text-field
              :label="$t('entities.account.props.name')"
              v-model="value.name"
              clearable
              :rules="$isRequiredRule"
            ></v-text-field>
          </v-form>
        </v-tab-item>
        <v-tab-item key="CustomFields" eager>
          <entity-field-custom-autoform v-model="value" entity="Account"></entity-field-custom-autoform>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-container>
</template>
<script>
export default {
  props: {
    value: {
      default() {
        return {
          code: "",
          name: "",
        };
      },
    },
  },

  data() {
    return {
      tab: null,
      customFieldsValues: {},
      customFields: [
        { label: "campo1", type: "numeric", group: "" },
        { label: "campo2", type: "numeric", group: "grupo1" },
        { label: "campo3", type: "numeric", group: "grupo2" },
      ],
      valid: false,
    };
  },
  watch: {
    value() {
      this.$refs.form.resetValidation();
    },
  },
  methods: {
    isValid() {
      return this.$refs.form.validate();
    },
  },
  created() {
    this.value.customFields = {};
  },
};
</script>